import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "headline cb-headlinenormalxl g-3"
}
const _hoisted_3 = {
  key: 1,
  class: "headline cb-headlinenormalxl g-3"
}
const _hoisted_4 = {
  key: 2,
  class: "row g-3"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "mb-3 mt-5 bold" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "bold"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "row agenda_item_full" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "row mb-5 mt-5" }
const _hoisted_16 = {
  key: 0,
  class: "col-lg-3 col-6"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "col-lg-3 col-6" }
const _hoisted_23 = { class: "Role copydetailxs" }
const _hoisted_24 = {
  key: 1,
  class: "col-lg-3 col-6"
}
const _hoisted_25 = { class: "Role copydetailxs" }
const _hoisted_26 = {
  key: 2,
  class: "col-lg-3 col-6"
}
const _hoisted_27 = { class: "Role copydetailxs" }
const _hoisted_28 = {
  key: 3,
  class: "mt-5 mb-5"
}
const _hoisted_29 = {
  key: 4,
  class: "embed-responsive embed-responsive-16by9"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { key: 5 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "row m-1" }
const _hoisted_34 = { class: "col-4 mb-3" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "col-8 mb-3" }
const _hoisted_37 = { class: "fw-bold mb-1" }
const _hoisted_38 = {
  key: 0,
  class: "small mb-1"
}
const _hoisted_39 = {
  key: 1,
  class: "small"
}
const _hoisted_40 = { class: "mt-2" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "row m-1" }
const _hoisted_44 = { class: "col-4 mb-3" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "col-8 mb-3" }
const _hoisted_47 = { class: "fw-bold mb-1" }
const _hoisted_48 = {
  key: 0,
  class: "small mb-1"
}
const _hoisted_49 = {
  key: 1,
  class: "small"
}
const _hoisted_50 = { class: "mt-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "row m-1" }
const _hoisted_54 = { class: "col-4 mb-3" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "col-8 mb-3" }
const _hoisted_57 = { class: "fw-bold mb-1" }
const _hoisted_58 = {
  key: 0,
  class: "small mb-1"
}
const _hoisted_59 = {
  key: 1,
  class: "small"
}
const _hoisted_60 = { class: "mt-2" }
const _hoisted_61 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconWebcam = _resolveComponent("IconWebcam")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.notFound)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Not found"))
      : _createCommentVNode("", true),
    (!_ctx.agendaEntry)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Loading"))
      : _createCommentVNode("", true),
    (_ctx.agendaEntry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", null, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fal fa-calendar-alt" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formatedDate(_ctx.agendaEntry.startdate, _ctx.agendaEntry.enddate)) + " CEST ", 1),
              _createVNode(_component_IconWebcam, {
                title: "Stream available",
                style: {"height":"1.7rem","line-height":"0","margin-top":"-0.4rem"}
              })
            ]),
            _createElementVNode("h4", _hoisted_6, [
              _createElementVNode("span", {
                innerHTML: _ctx.title(_ctx.agendaEntry.title)
              }, null, 8, _hoisted_7),
              (_ctx.agendaEntry.subtitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _cache[7] || (_cache[7] = _createTextVNode("- ")),
                    _createElementVNode("span", {
                      innerHTML: _ctx.agendaEntry.subtitle
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.agendaEntry.hosted_by)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _cache[8] || (_cache[8] = _createTextVNode(" Hosted by: ")),
                  _createElementVNode("div", {
                    innerHTML: _ctx.agendaEntry.hosted_by
                  }, null, 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", {
                  class: "Sendung_Beschreibung_full",
                  innerHTML: _ctx.agendaEntry.long_summary
                }, null, 8, _hoisted_14)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.agendaEntry.room?.length > 0 || _ctx.agendaEntry.location?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "headline_light text-center" }, "Takes place at", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                    (_ctx.agendaEntry.room)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fal fa-2x fa-map-marker-alt" }, null, -1)),
                          _createElementVNode("span", {
                            innerHTML: _ctx.agendaEntry.room
                          }, null, 8, _hoisted_18),
                          (_ctx.agendaEntry.location)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " - "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.agendaEntry.location)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.agendaEntry.location
                          }, null, 8, _hoisted_21)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "headline_light text-center" }, "Share on", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    class: "a-link--external share buttonshare",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.share('twitter','','en_us'))),
                    "data-label": "twitter"
                  }, _cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fab fa-2x fa-x-twitter me-2" }, null, -1),
                    _createElementVNode("span", { class: "sr-only" }, "X (Twitter)", -1)
                  ])),
                  _createElementVNode("a", {
                    class: "a-link--external share buttonshare",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.share('linkedin','','en_us'))),
                    "data-label": "linkedin"
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fab fa-2x fa-linkedin-in me-2" }, null, -1),
                    _createElementVNode("span", { class: "sr-only" }, "LinkedIn", -1)
                  ])),
                  _createElementVNode("a", {
                    class: "a-link--external share buttonshare",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.share('facebook','','en_us'))),
                    "data-label": "facebook"
                  }, _cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "fab fa-2x fa-facebook-f" }, null, -1),
                    _createElementVNode("span", { class: "sr-only" }, "Facebook", -1)
                  ])),
                  _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1))
                ])
              ]),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "headline_light text-center" }, "Bookmark", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                      (_ctx.include(_ctx.agendaEntry.objvalueid))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "a-link--external share buttonshare",
                            title: "Bookmark",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.unsetFav(_ctx.agendaEntry.objvalueid)))
                          }, _cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "fal fa-calendar-plus fa-2x" }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      (_ctx.exclude(_ctx.agendaEntry.objvalueid))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "a-link--external share buttonshare",
                            title: "Bookmark",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setFav(_ctx.agendaEntry.objvalueid)))
                          }, _cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "fal fa-calendar-minus fa-2x" }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "headline_light text-center" }, "ICS DOWNLOAD ", -1)),
                      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("a", {
                        class: "a-link--external share buttonshare",
                        title: "ICS Download",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generateFileICS(_ctx.agendaEntry.objvalueid)))
                      }, _cache[25] || (_cache[25] = [
                        _createElementVNode("i", { class: "fal fa-calendar-check fa-2x" }, null, -1)
                      ])),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                      _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.agendaEntry.show_video && _ctx.agendaEntry.video_link)
                ? (_openBlock(), _createElementBlock("hr", _hoisted_28))
                : _createCommentVNode("", true),
              (_ctx.agendaEntry.show_video && _ctx.agendaEntry.video_link)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("iframe", {
                      title: "",
                      class: "embed-responsive-item",
                      src: _ctx.agendaEntry.video_link,
                      frameborder: "0",
                      allow: "autoplay; fullscreen",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_30)
                  ]))
                : _createCommentVNode("", true),
              _cache[33] || (_cache[33] = _createElementVNode("hr", { class: "mt-5 mb-5" }, null, -1)),
              (_ctx.agendaEntry.show_area)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_ctx.speakersArray.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Speakers", -1)),
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speakersArray, (speaker, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-6 row",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("img", {
                                    src: `/files/members/${speaker.objvalueid}/foto.jpg?nocache=${(new Date()).getHours()}`,
                                    class: "rounded-circle img-fluid",
                                    onerror: "this.onerror=null;this.src='/projects/dw/gmf/assets/images/placeholder.jpg';",
                                    alt: "Speaker Image"
                                  }, null, 8, _hoisted_35)
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(speaker.firstname) + " " + _toDisplayString(speaker.lastname), 1),
                                  (speaker.position)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.title(speaker.position)), 1))
                                    : _createCommentVNode("", true),
                                  (speaker.orgname)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.title(speaker.orgname)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.navigateToSpeaker(speaker.objvalueid)),
                                      class: "btn btn-sm btn-outline-primary"
                                    }, "Details", 8, _hoisted_41)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.moderatorsArray.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _cache[31] || (_cache[31] = _createElementVNode("h3", null, "Moderators", -1)),
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moderatorsArray, (moderator, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-6 row",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("img", {
                                    src: `/files/members/${moderator.objvalueid}/foto.jpg?nocache=${(new Date()).getHours()}`,
                                    class: "rounded-circle img-fluid",
                                    onerror: "this.onerror=null;this.src='/projects/dw/gmf/assets/images/placeholder.jpg';",
                                    alt: "Moderator Image"
                                  }, null, 8, _hoisted_45)
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, _toDisplayString(moderator.firstname) + " " + _toDisplayString(moderator.lastname), 1),
                                  (moderator.position)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.title(moderator.position)), 1))
                                    : _createCommentVNode("", true),
                                  (moderator.orgname)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.title(moderator.orgname)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.navigateToSpeaker(moderator.objvalueid)),
                                      class: "btn btn-sm btn-outline-primary"
                                    }, "Details", 8, _hoisted_51)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.artistsArray.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _cache[32] || (_cache[32] = _createElementVNode("h3", null, "Artists", -1)),
                          _createElementVNode("div", _hoisted_53, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artistsArray, (artist, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-6 row",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("img", {
                                    src: `/files/members/${artist.objvalueid}/foto.jpg?nocache=${(new Date()).getHours()}`,
                                    class: "rounded-circle img-fluid",
                                    onerror: "this.onerror=null;this.src='/projects/dw/gmf/assets/images/placeholder.jpg';",
                                    alt: "Artist Image"
                                  }, null, 8, _hoisted_55)
                                ]),
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, _toDisplayString(artist.firstname) + " " + _toDisplayString(artist.lastname), 1),
                                  (artist.position)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.title(artist.position)), 1))
                                    : _createCommentVNode("", true),
                                  (artist.orgname)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.title(artist.orgname)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.navigateToSpeaker(artist.objvalueid)),
                                      class: "btn btn-sm btn-outline-primary"
                                    }, "Details", 8, _hoisted_61)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}